export const DOMAIN = "https://1stnations-security-quebec.com";
export const PHONE = "+1 807-770-0243";
export const PHONE_HREF = "tel:+18077700243";
export const EMAIL = "admin@1stnation-security.com";
export const EMAIL_HREF = "mailto:admin@1stnation-security.com";

export const T = {
  en: {
    brandTag: "Indigenous-Owned Security Guard Services — Quebec",
    nav: { services: "Services", locations: "Locations", guides: "Guides", careers: "Careers", contact: "Contact", home: "Home" },
    callNow: "Call Now",
    emailUs: "Email Us",
    heroBadge1: "100% First Nations Owned",
    heroBadge2: "BSP Quebec Licensed Guards",
    heroBadge3: "24/7 Dispatch",
    servicesTitle: "Security Services in Quebec",
    servicesSub: "Fourteen specialized security programs, delivered by BSP-licensed professionals in every region of Quebec.",
    citiesTitle: "Serving Every Region of Quebec",
    citiesSub: "From security guards in Montreal and a security company in Quebec City to an agence de sécurité in Laval or Longueuil — our guards and patrols cover 60+ Quebec cities and their surrounding communities.",
    searchCity: "Search a city (e.g. Montreal, Lévis, Rimouski)…",
    searchService: "Search a service (e.g. fire watch, patrol)…",
    allRegions: "All regions",
    viewCity: "View city",
    viewService: "View service",
    contactTitle: "Contact 1st Nations Security",
    contactSub: "No forms, no waiting. Speak directly with our dispatch — 24 hours a day, 7 days a week.",
    stickyCall: "+1 807-770-0243",
    stickyEmail: "admin@1stnation-security.com",
    dispatchLabel: "24/7 Dispatch Line",
    emailLabel: "Direct Email",
    footerTag: "100% Indigenous-owned security guard company serving every region of Quebec with licensed guards, mobile patrols and 24/7 dispatch.",
    footerServices: "Security Services",
    footerCities: "Top Cities",
    footerCompany: "Company",
    footerResources: "Quebec Security Resources",
    rights: "All rights reserved.",
    homeTitle: "Security Guard Services in Quebec | Montreal, Laval, Quebec City | 1st Nations Security",
    breadcrumbHome: "Home",
    breadcrumbServices: "Services",
    breadcrumbCities: "Locations",
    alsoIn: "Other security services in",
    nearbyTitle: "Security services near",
    allCitiesCta: "View all 60+ Quebec cities we serve",
    allServicesCta: "Explore all 14 security services",
    faqTitle: "Frequently Asked Questions",
    includedTitle: "What Is Included",
    industriesTitle: "Industries We Protect",
    whereTitle: "Where We Offer This Service",
    whyTitle: "Why Choose 1st Nations Security",
    needTitle: "Local Security Expertise",
    ctaBandTitle: "Need security guards today?",
    ctaBandSub: "Our dispatch answers 24/7 — in English and French. Call or email and get a quote for your site, event or patrol route.",
    indigenousTitle: "Proudly 100% First Nations Owned",
    otherLang: "Français",
    langCode: "en-CA",
    marquee: ["24/7 RAPID DISPATCH", "100% INDIGENOUS OWNED", "BSP LICENSED GUARDS", "60+ QUEBEC CITIES", "MOBILE PATROLS", "EVENT SECURITY", "FIRE WATCH", "CONSTRUCTION SITE SECURITY"],
    industries: ["Retail & Shopping Centres", "Construction & Development", "Healthcare & Hospitals", "Schools & Campuses", "Industrial & Mining", "Condominiums & Residential", "Events & Festivals", "Government & Municipal", "Transportation & Logistics", "Hotels & Hospitality"],
    homeFaq: [
      ["Is 1st Nations Security really Indigenous-owned?", "Yes. 1st Nations Security is a 100% First Nations owned security guard company. We are proud to create employment for Indigenous security professionals while delivering professional security guard services across Quebec."],
      ["Are your security guards licensed in Quebec?", "Yes. Every guard we deploy holds a valid agent licence issued by the Bureau de la sécurité privée (BSP), and our agency operates in compliance with Quebec's Private Security Act."],
      ["Which cities in Quebec do you cover?", "We provide security guard services in more than 60 Quebec cities, including Montreal, Quebec City, Laval, Gatineau, Longueuil, Sherbrooke, Saguenay, Lévis and Trois-Rivières, with mobile patrols reaching surrounding communities."],
      ["How fast can you deploy guards to my site?", "Our dispatch operates 24/7. Depending on the city and service, we can often have licensed guards or a patrol unit on site the same day. Call +1 807-770-0243 to confirm availability."]
    ]
  },
  fr: {
    brandTag: "Services de gardiens de sécurité appartenant aux Autochtones — Québec",
    nav: { services: "Services", locations: "Villes", guides: "Guides", careers: "Carrières", contact: "Contact", home: "Accueil" },
    callNow: "Appelez maintenant",
    emailUs: "Écrivez-nous",
    heroBadge1: "100 % propriété des Premières Nations",
    heroBadge2: "Gardiens licenciés par le BSP",
    heroBadge3: "Répartition 24/7",
    servicesTitle: "Services de sécurité au Québec",
    servicesSub: "Quatorze programmes de sécurité spécialisés, livrés par des professionnels licenciés par le BSP dans toutes les régions du Québec.",
    citiesTitle: "Au service de toutes les régions du Québec",
    citiesSub: "De Montréal à Sept-Îles : votre agence de sécurité à Laval comme à Longueuil, avec des gardiens et patrouilles couvrant plus de 60 villes du Québec et leurs communautés environnantes.",
    searchCity: "Rechercher une ville (ex. Montréal, Lévis, Rimouski)…",
    searchService: "Rechercher un service (ex. surveillance incendie, patrouille)…",
    allRegions: "Toutes les régions",
    viewCity: "Voir la ville",
    viewService: "Voir le service",
    contactTitle: "Contactez 1st Nations Security",
    contactSub: "Pas de formulaire, pas d'attente. Parlez directement à notre répartition — 24 heures sur 24, 7 jours sur 7.",
    stickyCall: "+1 807-770-0243",
    stickyEmail: "admin@1stnation-security.com",
    dispatchLabel: "Ligne de répartition 24/7",
    emailLabel: "Courriel direct",
    footerTag: "Compagnie de gardiens de sécurité 100 % autochtone desservant toutes les régions du Québec avec gardiens licenciés, patrouilles mobiles et répartition 24/7.",
    footerServices: "Services de sécurité",
    footerCities: "Principales villes",
    footerCompany: "Entreprise",
    footerResources: "Ressources sécurité du Québec",
    rights: "Tous droits réservés.",
    homeTitle: "Agence de sécurité au Québec | Montréal, Laval, Québec | 1st Nations Security",
    breadcrumbHome: "Accueil",
    breadcrumbServices: "Services",
    breadcrumbCities: "Villes",
    alsoIn: "Autres services de sécurité à",
    nearbyTitle: "Services de sécurité près de",
    allCitiesCta: "Voir les 60+ villes du Québec desservies",
    allServicesCta: "Explorer les 14 services de sécurité",
    faqTitle: "Foire aux questions",
    includedTitle: "Ce qui est inclus",
    industriesTitle: "Industries que nous protégeons",
    whereTitle: "Où nous offrons ce service",
    whyTitle: "Pourquoi choisir 1st Nations Security",
    needTitle: "Expertise locale en sécurité",
    ctaBandTitle: "Besoin de gardiens de sécurité aujourd'hui?",
    ctaBandSub: "Notre répartition répond 24/7 — en français et en anglais. Appelez ou écrivez pour obtenir une soumission pour votre site, événement ou route de patrouille.",
    indigenousTitle: "Fièrement 100 % propriété des Premières Nations",
    otherLang: "English",
    langCode: "fr-CA",
    marquee: ["RÉPARTITION RAPIDE 24/7", "100 % AUTOCHTONE", "GARDIENS LICENCIÉS BSP", "60+ VILLES DU QUÉBEC", "PATROUILLES MOBILES", "SÉCURITÉ ÉVÉNEMENTIELLE", "SURVEILLANCE INCENDIE", "GARDIENNAGE DE CHANTIER"],
    industries: ["Commerce de détail et centres commerciaux", "Construction et développement", "Santé et hôpitaux", "Écoles et campus", "Industrie et mines", "Condominiums et résidentiel", "Événements et festivals", "Gouvernement et municipal", "Transport et logistique", "Hôtels et accueil"],
    homeFaq: [
      ["1st Nations Security est-elle vraiment une entreprise autochtone?", "Oui. 1st Nations Security est une compagnie de gardiens de sécurité détenue à 100 % par les Premières Nations. Nous sommes fiers de créer de l'emploi pour des professionnels autochtones de la sécurité tout en offrant des services de gardiennage professionnels partout au Québec."],
      ["Vos gardiens de sécurité sont-ils licenciés au Québec?", "Oui. Chaque gardien déployé détient un permis d'agent valide émis par le Bureau de la sécurité privée (BSP), et notre agence opère en conformité avec la Loi sur la sécurité privée du Québec."],
      ["Quelles villes du Québec couvrez-vous?", "Nous offrons des services de gardiens de sécurité dans plus de 60 villes du Québec, dont Montréal, Québec, Laval, Gatineau, Longueuil, Sherbrooke, Saguenay, Lévis et Trois-Rivières, avec des patrouilles mobiles rejoignant les communautés environnantes."],
      ["En combien de temps pouvez-vous déployer des gardiens?", "Notre répartition fonctionne 24/7. Selon la ville et le service, nous pouvons souvent avoir des gardiens licenciés ou une unité de patrouille sur place le jour même. Appelez le +1 807-770-0243 pour confirmer la disponibilité."]
    ]
  }
};

// Route helpers — all slugs are NEW and never duplicate the legacy 1stnation-security.com URL scheme
export const paths = (lang) => ({
  home: lang === "fr" ? "/fr" : "/",
  services: lang === "fr" ? "/fr/services-de-securite" : "/security-services",
  service: (s) => (lang === "fr" ? `/fr/services-de-securite/${s}` : `/security-services/${s}`),
  combo: (s, c) => (lang === "fr" ? `/fr/services-de-securite/${s}/${c}` : `/security-services/${s}/${c}`),
  cities: lang === "fr" ? "/fr/villes-quebec" : "/quebec-locations",
  city: (c) => (lang === "fr" ? `/fr/villes-quebec/${c}` : `/quebec-locations/${c}`),
  guides: lang === "fr" ? "/fr/guides" : "/guides",
  guide: (g) => (lang === "fr" ? `/fr/guides/${g}` : `/guides/${g}`),
  careers: lang === "fr" ? "/fr/carrieres" : "/careers",
  contact: lang === "fr" ? "/fr/contact" : "/contact"
});

export const otherLangPath = (pathname) => {
  if (pathname === "/fr" || pathname.startsWith("/fr/")) {
    let p = pathname.replace(/^\/fr/, "") || "/";
    p = p
      .replace("/services-de-securite", "/security-services")
      .replace("/villes-quebec", "/quebec-locations")
      .replace("/carrieres", "/careers");
    return p;
  }
  let p = pathname
    .replace("/security-services", "/services-de-securite")
    .replace("/quebec-locations", "/villes-quebec")
    .replace("/careers", "/carrieres");
  return `/fr${p === "/" ? "" : p}`;
};

export const langFromPath = (pathname) => (pathname === "/fr" || pathname.startsWith("/fr/") ? "fr" : "en");
